// extracted by mini-css-extract-plugin
module.exports = {"container":"CookieSettings_container__81Bk9","option":"CookieSettings_option__2kR3K","saveButton":"CookieSettings_saveButton__LapV7"};